// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"61a01f13","371":"976aae30","475":"8f869eb6","480":"8d735634","515":"0951be1b","631":"3ecfc7cf"}[chunkId] + ".chunk.css";
};